import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import axios from 'axios';
import Loading from './Loading';

export default function Screen3({ onNext, productCode }) {
  const [retailersByGeo, setRetailersByGeo] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (productCode) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            `https://epremise-api.b-fonline.com/product/${productCode}`
          );
          setRetailersByGeo(response.data.retailers_by_geo); // Store retailers by geographical location
          setLoading(false);
        } catch (err) {
          setError(err);
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [productCode]);

  const handleStateSelection = (state, retailers) => {
    onNext(null, { state, retailers });
  };

  // If the state in retailersByGeo is all, then we can directly select the state
  const allRetailers = retailersByGeo.all;
  if (allRetailers) {
    handleStateSelection('your region', allRetailers);
  }

  if (loading) return <Loading />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <>
      <div id='bf-chat-window-screen-3' className='screen'>
        <div className='wrapper'>
          <div className='row'>
            <div className='col'>
              <h2 className='title'>Select your location</h2>
              <ul className='select-state'>
                {Object.entries(retailersByGeo).map(([state, retailers]) => (
                  <li key={state}>
                    <button
                      onClick={() => handleStateSelection(state, retailers)}
                      className='btn'
                    >
                      {state}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Screen3.propTypes = {
  onNext: PropTypes.func.isRequired,
  productCode: PropTypes.string.isRequired,
};
